import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ParameterRowValue {
  key: string;
  value: string;
}

/**
 * A single add/remove-able row in the QuPath script composer's parameters table
 * (`ScriptRequest.parameters`, a free-form `Map<String,Object>` a script reads whatever keys it
 * defines itself - there's no fixed schema to validate against). Modeled directly on
 * `MetadataFilterRowComponent` - same plain-array, immutable-update-by-index, self-contained-row
 * house style - just two text inputs instead of a field/operator/value chain.
 */
@Component({
  selector: 'parameter-row',
  templateUrl: './parameter-row.component.html',
  styleUrls: ['./parameter-row.component.scss'],
})
export class ParameterRowComponent {

  @Input() set row(r: ParameterRowValue) {
    this.key = r.key;
    this.value = r.value;
  }

  @Output() rowChange = new EventEmitter<ParameterRowValue>();
  @Output() remove = new EventEmitter<void>();

  key = '';
  value = '';

  onChange(): void {
    this.rowChange.emit({ key: this.key, value: this.value });
  }
}
